// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-autocomplete-flex {\r\n\tdisplay: flex;\r\n\twidth: 100%;\r\n\tflex-wrap: wrap;\r\n}\r\n.filter-autocomplete-flex > div:first-child {\r\n\tflex: 1 1;\r\n\t\r\n}", ""]);
// Exports
module.exports = exports;
